var _defs, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBottomWaveBlue(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 3839.576,
    height: 563.588,
    viewBox: "0 0 3839.576 563.588",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#5877ad"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2654A2"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_455",
    "data-name": "Path 455",
    d: "M-5536.524,1845.677c61.144,0,122.288,14.9,170.407,44.71l102.8,63.676c110.2,68.263,284.4,56.95,373.054-24.227l110.987-101.629c100.382-91.917,304.912-91.917,405.293,0L-4263,1929.836c88.652,81.177,262.851,92.49,373.054,24.227l81.9-50.733c104.535-64.752,268.256-58.4,360.967,14.013l119.723,93.505c100.251,78.3,280.868,78.3,381.119,0l119.723-93.505c92.711-72.409,256.432-78.765,360.967-14.013l118.238,73.239c96.24,59.614,244.575,59.614,340.815,0l139.132-86.182c48.121-29.807,109.264-44.71,170.408-44.71v477.18H-5536.524Z",
    transform: "translate(5536.524 -1759.269)",
    fill: "url(#linear-gradient)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBottomWaveBlue);
export default __webpack_public_path__ + "static/media/bottom_wave_blue.283feb2dae3d54520d2f5f597e41d3af.svg";
export { ForwardRef as ReactComponent };